import webApp from "../../../Assets/image/services/web-app-development.webp";
import customSoftware from "../../../Assets/image/services/custom-software-development.webp";
import mobileApp from "../../../Assets/image/services/mobile-app-development.webp";
import staff from "../../../Assets/image/staff-augmentation.webp";
import aiAgent from "../../../Assets/image/ai-agent-development.webp";
import genAi from "../../../Assets/image/gen-ai-solution.webp";
import aiIntegration from "../../../Assets/image/services/ai-integration-services.webp";

const services = [
  {
    id: 1,
    title: "Web Development",
    path: "/web-development-company",
    description:
      "Transform your digital presence with cutting-edge web development. We craft responsive, high-speed, and conversion-driven websites designed to maximize engagement, enhance user experience, and drive business growth.",
    image: webApp,
  },
  {
    id: 2,
    title: "Mobile Development",
    path: "/mobile-app-development-company",
    description:
      "Turn your app idea into a reality with high-performance, feature-rich mobile applications for iOS and Android. We focus on user-centric design, scalability, and advanced functionality to ensure a seamless mobile experience.",
    image: mobileApp,
  },
  {
    id: 3,
    title: "Custom SaaS Development",
    path: "/custom-saas-development-company",
    description:
      "Build cloud-based, multi-tenant Software-as-a-Service (SaaS) platforms with robust subscription billing, security, and scalability.",
    image: customSoftware,
  },
  {
    id: 4,
    title: "AI Agent Development",
    path: "/ai-agent-development-company",
    description:
      "Deploy intelligent, autonomous AI agents capable of reasoning, execution, task automation, and integration with your workflows.",
    image: aiAgent,
  },
  {
    id: 5,
    title: "Gen AI Solutions",
    path: "/generative-ai-solutions-company",
    description:
      "Leverage LLMs, image generation models, and retrieval-augmented generation (RAG) to build custom generative AI applications.",
    image: genAi,
  },
  {
    id: 6,
    title: "AI Integration Services",
    path: "/ai-integration-services-company",
    description:
      "Infuse AI capabilities into your existing software, databases, and APIs for smarter analytics and decision-making.",
    image: aiIntegration,
  },
  {
    id: 7,
    title: "Staff Augmentation",
    path: "/hire-a-developer",
    description:
      "We provide skilled professionals to extend your team and meet your project goals. Our experts are ready to integrate seamlessly with your workflows.",
    image: staff,
  },
];

export default services;
